/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TranslationsGetResponse } from '../models/TranslationsGetResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TranslationService {

    /**
     * @returns TranslationsGetResponse OK
     * @throws ApiError
     */
    public static get(): CancelablePromise<TranslationsGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Translation',
        });
    }

}
